/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-03 12:00:00
 *
 *******************************************************/
import React, { Component } from 'react';
import { Button, Popover, ActionList, Icon } from '@shopify/polaris';
import { MobileHorizontalDotsMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { isThemeV3 } from 'src/helpers/theme-setup-helper';
import { freeThemes, themeSupportV2 } from 'src/constants/theme-setup';

type Props = {
  handleRemove: Function,
  handleRemoveThemeV3: Function,
};

type ComposedProps = Props & WithI18nProps;

class PopoverActionButton extends Component<ComposedProps> {
  state = {
    active: false
  };

  togglePopover = () => {
    this.setState(({ active }) => {
      return { active: !active };
    });
  };

  getMenuActions = props => {
    const {
      i18n,
      theme = {},
      handleRemoveThemeV3,
      storeExpired
    } = props;
    const { shopifyThemeName } = theme;
    const themeLibV3 = isThemeV3(theme);
    const isThemeSupportV2 = themeSupportV2.includes(shopifyThemeName);

    let menuActions = [];
    if (themeLibV3) {
      menuActions.push({
        content: i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.remove'),
        onAction: () => handleRemoveThemeV3(theme)
      });
    } else {
      menuActions.push(
        ...[
          {
            content: i18n.translate('AdminHTML.ThemeSetup.Themes.removeSearch'),
            onAction: () => this.handleRemove(false)
          },
          {
            content: i18n.translate('AdminHTML.ThemeSetup.Themes.removeAll'),
            onAction: () => this.handleRemove(true)
          }
        ]
      );

      // theme is chosen = not supported theme
      if (!isThemeSupportV2 && !storeExpired) {
        menuActions.push(
          ...[
            {
              content: i18n.translate('AdminHTML.MainMenu.quickViewCartSettings'),
              id: 'menu-theme-quick-view-cart-settings',
              onAction: () => history.push(routes.quickViewCartSettings.view())
            },
            {
              content: i18n.translate('AdminHTML.MainMenu.defaultThemeSettings'),
              id: 'menu-theme-default-theme-settings',
              onAction: () => history.push(routes.defaultThemeSettings.view())
            }
          ]
        );
      }

      // theme is chosen = supported theme and free
      if (isThemeSupportV2 && freeThemes.includes(theme.shopifyThemeName) && !storeExpired) {
        menuActions.push(
          ...[
            {
              content: i18n.translate('AdminHTML.MainMenu.quickViewCartSettings'),
              id: 'menu-theme-quick-view-cart-settings',
              onAction: () => history.push(routes.quickViewCartSettings.view())
            }
          ]
        );
      }

      // theme is chosen = supported theme and not free
      if (isThemeSupportV2 && !freeThemes.includes(theme.shopifyThemeName)) {
      }
    }

    return menuActions;
  };

  render() {
    const { disabled } = this.props;
    const { active } = this.state;
    const activator = (
      <div className="Theme__ActionMenu">
        <Button onClick={this.togglePopover} disabled={disabled}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <Icon source={MobileHorizontalDotsMajor} />
          </span>
        </Button>
      </div>
    );

    const menuActions = this.getMenuActions(this.props);

    return (
      <Popover active={active} activator={activator} onClose={this.togglePopover}>
        <Popover.Pane>
          <ActionList items={menuActions} />
        </Popover.Pane>
      </Popover>
    );
  }

  handleRemove = removeAll => {
    const { handleRemove } = this.props;
    this.togglePopover();
    handleRemove(removeAll);
  };
}

export default withI18n()(PopoverActionButton);
